import { computed } from 'vue';
var __default__ = {
  name: "DailySummaryTable"
};
export default /*#__PURE__*/Object.assign(__default__, {
  props: {
    monthData: {
      /** @type {PropType<MonthData[]>} */
      type: Array,
      required: true
    },
    summaryKey: {
      type: String,
      required: true
    },
    summaryValue: {
      type: Array,
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props; // @ts-check

    var days = computed(function () {
      return props.monthData.length;
    });
    return {
      __sfc: true,
      props: props,
      days: days
    };
  }
});